import React,{Component} from "react";
import {
  Card,
  CardHeader,
  Button,
  ListGroup,
  ListGroupItem,
  Row,
  Col
} from "shards-react";
import { Modal } from 'react-bootstrap';

export default class ViewStudent extends Component{
  render(){

    return(
      <Modal show={this.props.show} onHide={this.props.handleClose}>
          
            <StudentDet handleClose={this.props.handleClose} data={this.props.data} edit_student={this.props.edit_student}/>
       
      </Modal>
    )
  }
}

class StudentDet extends Component{

  render(){

    return(
  <Card small className="mb-4 pt-3">
    <CardHeader className="border-bottom text-center">
      <div className="mb-3">
        <img
          className="rounded-circle"
          src={this.props.data.photo_url}
          alt={"No img"}
          width="110"
        />
      </div>
      <h4 className="mb-0">{this.props.data.name}</h4>
      <span className="text-muted d-block mb-2">{this.props.data.class}</span>
      <Button pill outline size="sm" className="mb-2" onClick={()=>{this.props.edit_student(this.props.data.class+""+this.props.data.roll_no)}}>
        <i className="material-icons mr-1">edit</i> Edit Student
      </Button>
    </CardHeader>
    <ListGroup flush>

      <Item field="Roll No" value={this.props.data.roll_no} />
      <Item field="Date of Admission" value={this.props.data.dateofadmission} />
      <Item field="DOB" value={this.props.data.dob} />
      <Item field="Gender" value={this.props.data.gender} />
      <Item field="Mother Name" value={this.props.data.mother_name} />
      <Item field="Father Name" value={this.props.data.father_name} />
      <Item field="Phone" value={this.props.data.phone} />
      <Item field="Address" value={this.props.data.address} />


      
      <ListGroupItem>
          <Button style={{width:'20%',marginLeft:'80%'}}  theme="info" onClick={this.props.handleClose}>
              OK
        </Button> 
      </ListGroupItem>
    </ListGroup>
    
       
  
  </Card>
);
}

}

class Item extends Component{
  render(){
    return(
      <ListGroupItem className="px-4">
        <div className="progress-wrapper">
          <Row>
          <Col md="6">
          <strong className=" d-block mb-2" style={{marginLeft: '5%',color:'blue'}}>
            {this.props.field}
          </strong>
          </Col>
          <Col md="6">
          <strong className="d-block mb-2" style={{marginLeft: '2%'}}>
            {this.props.value}
          </strong>
          </Col>
        </Row>

    
        </div>
      </ListGroupItem>
    )
  }
}
